import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
// import VCharts from 'v-charts'
import ECharts from 'vue-echarts' // 引入 vue-charts
import 'echarts' // 引入 echarts（必须
import dataV from '@jiaminghi/data-view' // 引入dataV做大屏显示

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control
import FilterBox from '@/views/layout/FilterBox' //筛选搜索折叠/展开

Vue.use(ElementUI, { locale })
Vue.use(dataV)
// Vue.use(VCharts)
Vue.component('v-chart', ECharts)

Vue.component('FilterBox', FilterBox)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

//fix el-select
let fixElSelect = function () {
  document.querySelectorAll('.el-select[data-is-search="true"]:hover').forEach((v) => {
    let elInput = document.querySelector('.el-select[data-is-search="true"]:hover input[readonly]');
    if (elInput) {
      elInput.readOnly = false;
      elInput.blur();
      elInput.focus();
    }
  });
};
document.addEventListener("focusin", fixElSelect);
document.addEventListener("click", fixElSelect);
document.addEventListener("touchstart", fixElSelect);


// WEBPACK FOOTER //
// ./src/main.js